<template>
    <Row :gutter="10" class="sylg-page" style="margin-left: 0; margin-right: 0;height: 95%;">
        <Col span="24" class="full" style="padding: 0;">
            <Card class="full full-card sylg-page-card">
                <p slot="title" style="display: flex">
                    <span class="page-title">
                        <Icon :type="icon" class="margin-right-10"/>
                        {{title}}
                    </span>
                    <span class="bread" style="display: inline">
                            [
                            <!--<Breadcrumb style="display: inline">-->
                                <!--<BreadcrumbItem :class="'otherRouter' == route.name ? 'my-breadcrumb-item':''" v-for="(route) in $route.matched" :key="route.name">{{$t(route.meta.title)}}</BreadcrumbItem>-->
                            <!--</Breadcrumb>-->
                            <span v-for="(route,index) in $route.matched" :key="index">
                                <span>{{$t(route.meta.title)}}</span>
                                <span v-if="index != 1 && 'otherRouter' != route.name" class="margin-left-5 margin-right-5">/</span>
                            </span>
                            ]
                        </span>
                </p>
                <Form slot="extra" inline style="float:right;">
                    <slot name="extra"></slot>
                </Form>
                <div class="flex-container-column full">
                    <div class="margin-top-10" style="flex-grow: 1; height: calc(100% - 10px);">
                        <slot></slot>
                    </div>
                </div>
            </Card>
        </Col>
    </Row>
</template>

<script>
    export default {
        name: "base-page",
        props: {
            title: {
                type: String,
                default: "页面标题"
            },
            icon: {
                type: String,
                default: 'md-browsers'
            }
        },
        created(){

        }
    }
</script>

<style scoped>
    .sylg-page {
        width: 100%;
        height: calc(100% - 30px);
        background-color: #dfe6e9;
    }
    .bread {
        padding-left: 1em;
    }
    .bread * {
        font-size: 0.9em;
    }
    .page-title {
        cursor: default;
        font-size: 18px;
        display: flex;
    }
    /*.page-title:hover+.bread {*/
        /*display: inline-block;*/
    /*}*/
</style>